import { validatePatternConfiguration } from '@df/ui/form/validate-pattern.config';

validatePatternConfiguration['telephone'] = {
    pattern: /^[0-9 +\-()]{7,}$/,
    errorMessage: 'Please enter a valid phone number'
};
